import { lazy, Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import RootLayout from "../pages/components/RootLayout";
import { ErrorPage } from "../pages/ErrorPage/ErrorPage";
import LoadingPage from "../components/LoadingPage";
import ProjectsMain from "../pages/Projects/components/Main";
import SharedProjects from "../pages/Projects/components/SharedProjects";
import LandingPaage from "../pages/LandingPage";
import ResetPWD from "../pages/ResetPWD";
import RecoverPassword from "../pages/RecoverPWD";
import MySharedProjects from "../pages/Projects/components/MySharedProjects";
import MyTeamProjects from "../pages/Projects/components/MyTeamProjects";
import Solutions from "../pages/Solutions";
import SolutionsApp from "../pages/components/SolutionsApp";
import AuthorizedRoutes from "./AuthorizedRoutes";
import ProtectedRoutes from "./ProtectedRoutes";
import LinkedInCallback from "../pages/LinkedInCallback";
import NumberOfUsers from "../pages/NumberOfUsers";

const FlowLazy = lazy(() => import("../pages/DigramCreator"));
const ProjectsLazy = lazy(() => import("../pages/Projects"));
const LoginLazy = lazy(() => import("../pages/Login/Login"));
const RegisterLazy = lazy(() => import("../pages/Register/Register"));
const WizardsPageLazy = lazy(() => import("../pages/Wizards"));
const ProjectPreviewPageLazy = lazy(() => import("../pages/ProjectPreview"));
const ThanksForSigningUpLazy = lazy(
  () => import("../pages/ThanksForSigningUp")
);

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <LandingPaage />,
      },
      { path: "oauth/linkedin/callback", element: <LinkedInCallback /> },
      {
        path: "preview",
        element: (
          <Suspense fallback={<LoadingPage />}>
            <ProtectedRoutes>
              <ProjectPreviewPageLazy />
            </ProtectedRoutes>
          </Suspense>
        ),
      },
      {
        path: "nou",
        element: (
            <NumberOfUsers />
        ),
      },
      {
        path: "/wizards/:teamId",
        element: (
          <Suspense fallback={<LoadingPage />}>
            <WizardsPageLazy />
          </Suspense>
        ),
      },

      {
        path: "codeyai/diagram/:projectId",
        element: (
          <Suspense fallback={<LoadingPage />}>
            <FlowLazy />
          </Suspense>
        ),
      },
      {
        path: "codeyai/projects",

        element: (
          <Suspense fallback={<LoadingPage />}>
            <ProjectsLazy />
          </Suspense>
        ),
        children: [
          { index: true, element: <ProjectsMain /> },
          { path: "shared", element: <SharedProjects /> },
          { path: "myshared", element: <MySharedProjects /> },
          { path: "teamProjects", element: <MyTeamProjects /> },
        ],
      },
    ],
  },
  {
    path: "login",
    element: (
      <Suspense fallback={<LoadingPage />}>
        <AuthorizedRoutes>
          <LoginLazy />
        </AuthorizedRoutes>
      </Suspense>
    ),
  },
  {
    path: "register",
    element: (
      <Suspense fallback={<LoadingPage />}>
        <AuthorizedRoutes>
          <RegisterLazy />
        </AuthorizedRoutes>
      </Suspense>
    ),
  },
  {
    path: "thanksForSigningup",
    element: (
      <Suspense fallback={<LoadingPage />}>
        <AuthorizedRoutes>
          <ThanksForSigningUpLazy />
        </AuthorizedRoutes>
      </Suspense>
    ),
  },
  {
    path: "reset-password",
    element: (
      <AuthorizedRoutes>
        <ResetPWD />
      </AuthorizedRoutes>
    ),
  },
  {
    path: "recover-password",
    element: (
      <AuthorizedRoutes>
        <RecoverPassword />
      </AuthorizedRoutes>
    ),
  },
  {
    path: "solutions",
    element: <SolutionsApp />,
    children: [{ index: true, element: <Solutions /> }],
  },
]);
